import React from "react";
import PropTypes from "prop-types";
import styles from "../styles/components/BulletedList.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquare } from "@fortawesome/pro-solid-svg-icons";
import { history } from "../store";

const defaultClassNames = {
    container: styles.listItem,
    header: styles.headlineText,
    link: styles.link,
    bulletList: `fa-ul ${styles.bullets}`,
    bulletContainer: styles.bullet,
    bulletText: styles.bulletText,
    bulletIcon: styles.bulletIcon
};

export const Bullet = ({ classNames, text, bulletIcon }) => (
    <li className={classNames.bulletContainer}>
        <p className={classNames.bulletText}>
            <FontAwesomeIcon
                className={classNames.bulletIcon}
                icon={bulletIcon}
            />{" "}
            {text}
        </p>
    </li>
);

Bullet.propTypes = {
    classNames: {
        bulletContainer: PropTypes.string,
        bulletText: PropTypes.string,
        bulletIcon: PropTypes.string
    },
    text: PropTypes.string.isRequired
};

export class BulletedListItem extends React.Component {
    static propTypes = {
        headline: PropTypes.string.isRequired,
        href: PropTypes.string,
        bullets: PropTypes.arrayOf(PropTypes.string),
        bulletIcon: PropTypes.object,
        classNames: PropTypes.shape({
            container: PropTypes.string,
            header: PropTypes.string,
            link: PropTypes.string,
            bulletList: PropTypes.string,
            bulletContainer: PropTypes.string,
            bulletText: PropTypes.string,
            bulletIcon: PropTypes.string
        })
    };

    static defaultProps = {
        bullets: [],
        bulletIcon: faSquare,
        classNames: defaultClassNames
    };

    render() {
        const classNames = {
            ...defaultClassNames,
            ...this.props.classNames
        };
        return (
            <li
                className={`${classNames.container} ${
                    this.props.href ? styles.link : ""
                }`}
                onClick={
                    this.props.href ? () => history.push(this.props.href) : null
                }
            >
                <h3 className={classNames.header}>{this.props.headline}</h3>
                {this.props.bullets.length > 0 && (
                    <ul className={`fa-ul ${classNames.bulletList}`}>
                        {this.props.bullets.map((text, index) => (
                            <Bullet
                                key={index}
                                text={text}
                                classNames={classNames}
                                bulletIcon={this.props.bulletIcon}
                            />
                        ))}
                    </ul>
                )}
            </li>
        );
    }
}

export const BulletedList = ({ className, children, ...props }) => (
    <ul className={className} {...props}>
        {children}
    </ul>
);

BulletedList.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired
};

BulletedList.defaultProps = {
    className: styles.list
};



// WEBPACK FOOTER //
// ./src/components/BulletedList.js